import { useHistoryRestoreStore } from '@/stores/historyRestoreStore';
import { useOpenIntentStore } from '@/stores/openIntentStore';
import { clearCalculationSession } from '@/utils/calculationSessionStorage';

export function clearPersistedHistorySessionContext() {
  clearCalculationSession();
  useHistoryRestoreStore().clearRecord();
  useOpenIntentStore().clearIntent();
}

export function clearHistorySessionContext(vm) {
  if (vm && typeof vm === 'object') {
    vm.historyOpenMode = null;
    vm.historyReadOnly = false;
    vm.historySourceDisplayName = '';
    vm.historySourceCreatedAt = '';
    vm.historySourceRunId = null;
  }
  clearPersistedHistorySessionContext();
}
